import {
    TOP_RATED_LAWYERS
  } from '../constants/types';

  export default function(state=[], action){
    switch(action.type){
      case TOP_RATED_LAWYERS:
        return action.payload
      default:
        return state
    }
  }
